import { Parchment } from 'quill/core';

const WHITE_LIST = ['full', 'half'] as const satisfies string[];

export type SpanValue = (typeof WHITE_LIST)[number];

export default new Parchment.ClassAttributor('span', 'span', {
  scope: Parchment.Scope.BLOCK,
  whitelist: WHITE_LIST,
});
